import { render, staticRenderFns } from "./TabFuture.vue?vue&type=template&id=45badbed&scoped=true"
import script from "./TabFuture.vue?vue&type=script&lang=js"
export * from "./TabFuture.vue?vue&type=script&lang=js"
import style0 from "./TabFuture.vue?vue&type=style&index=0&id=45badbed&prod&lang=scss&scoped=true"
import style1 from "./TabFuture.vue?vue&type=style&index=1&id=45badbed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45badbed",
  null
  
)

export default component.exports